<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="row d-flex align-items-center">
          <div class="mr-auto col-12 col-sm-7">
            <h1 class="m-subheader__title" v-encode="pageTitle"></h1>
          </div>
          <div class="col-12 col-sm-5 d-flex">
            <span class="m-subheader__daterange mt-2 mt-md-0 ml-0 ml-sm-auto" id="m_dashboard_daterangepicker">
              <span class="m-subheader__daterange-label">
                <span class="m-subheader__daterange-title"></span>
                <span class="m-subheader__daterange-date m--font-info"></span>
              </span>
              <date-range-picker :opens="opens"
                                 :start-date="startDate"
                                 :end-date="endDate"
                                 @update="onDateRangeUpdate"></date-range-picker>
            </span>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="m_widget2_tab1_content" aria-expanded="true">
                <timeline :items="messages" :component="timelineItem" :empty-text="$t('No messages')"></timeline>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Timeline from "../timeline/Timeline"
import moment from 'moment'
import DateRangePicker from '@/components/datepicker/DateRangePicker'
import Page from "./Page";
import MessageTimelineItem from "@/components/timeline/items/MessageTimelineItem";
import Screen from "@/mixins/screen";
import BeforeRoute from "@/mixins/beforeRoute";
import PageTitle from "@/mixins/pageTitle";
import Encode from "@/directives/encode";

export default {
  name: "MessagesPage",
  components: {MessageTimelineItem, Page, Timeline, DateRangePicker},
  directives: {Encode},
  mixins: [
    Screen,
    BeforeRoute('fetchMessages'),
    PageTitle('Wiadomości'),
  ],
  data() {
    return {
      timelineItem: MessageTimelineItem,
    };
  },
  mounted() {
    this.resetDates('messages')
  },
  methods: {
    ...mapActions([
      'resetDates',
      'setMessagesDates',
    ]),
    onDateRangeUpdate(values) {
      this.setMessagesDates({
        startDate: moment(values.startDate).format("YYYY-MM-DD"),
        endDate: moment(values.endDate).format("YYYY-MM-DD")
      })
    }
  },
  computed: {
    ...mapState({
      startDate: state => state.datePicker.dates.messages.startDate,
      endDate: state => state.datePicker.dates.messages.endDate,
      stateMessages: state => state.messages.messages,
    }),
    messages() {
      return this.stateMessages.filter(
          (m) => moment(m.date_sent).isSameOrAfter(`${this.startDate} 00:00:00`)
              && moment(m.date_sent).isSameOrBefore(`${this.endDate} 23:59:59`)
      );
    },
    opens() {
      return this.windowWidth <= 575 ? 'center' : 'left';
    },
  }
}
</script>

<style scoped>

</style>
